'use client'

interface LogoProps {
  width?: number
  height?: number
  className?: string
}

export function Logo({ width = 200, height = 60, className = '' }: LogoProps) {
  return (
    <div
      className={className}
      style={{ width, height }}
    >
      <svg 
        id="Layer_1" 
        xmlns="http://www.w3.org/2000/svg" 
        version="1.1" 
        viewBox="0 0 999.3 350.1"
        width="100%"
        height="100%"
        className="[&_path]:fill-primary [&_polygon]:fill-primary dark:[&_path]:fill-white dark:[&_polygon]:fill-white"
      >
        <g>
          <g>
            <path d="M114.4,114.1c-33.6,0-60.9,27.3-60.9,60.9s27.3,60.9,60.9,60.9,60.9-27.3,60.9-60.9-27.3-60.9-60.9-60.9ZM114.4,202.7c-15.3,0-27.7-12.4-27.7-27.7s12.4-27.7,27.7-27.7,27.7,12.4,27.7,27.7-12.4,27.7-27.7,27.7Z"/>
            <polygon points="295.7 139.6 270.9 114.8 235.5 150.2 200.1 114.8 175.3 139.6 210.7 175 175.3 210.4 200.1 235.2 235.5 199.8 270.9 235.2 295.7 210.4 260.3 175 295.7 139.6"/>
          </g>
          <path d="M175,31c48.1,0,91.8,13.2,111.3,33.6l.2.2.2.2c19.8,20,32.5,63.8,32.1,111.8-.3,46.9-13.2,89.7-32.8,108.8l-.2.2-.2.2c-19.6,20-63.1,32.9-110.7,32.9s-91.1-12.9-110.7-32.9l-.2-.2-.2-.2c-20-19.6-32.9-63.1-32.9-110.8s12.9-91.1,32.9-110.7l.2-.2.2-.2c19.7-20,63.2-33,110.8-33M175,0C122.4,0,69.8,14.1,42.2,42.2c-56.2,55.2-56.2,210.4,0,265.7,27.6,28.1,80.2,42.2,132.8,42.2s105.2-14.1,132.8-42.2c56-54.8,56-209.3,1-264.6C281.2,14.4,228,.1,175,.1h0Z"/>
        </g>
        <g>
          <path d="M376.9,174.9c0-32.8,24-56.8,58.1-56.8s58.1,24,58.1,56.8-24,56.8-58.1,56.8-58.1-24-58.1-56.8ZM466.7,174.9c0-19-12.7-32.6-31.7-32.6s-31.9,13.6-31.9,32.6,12.9,32.6,31.9,32.6,31.7-13.6,31.7-32.6Z"/>
          <path d="M525.7,173.8l-38-52.9h31.5l26,38.9,26-38.9h30.8l-38.5,52.9,40.2,55.1h-31.5l-28-41.5-27.8,41.5h-30.6l39.8-55.1h0Z"/>
          <path d="M606.8,89.7c0-10.1,7.2-17.5,17.3-17.5s17.3,7.4,17.3,17.5-7.2,17.3-17.3,17.3-17.3-7.2-17.3-17.3ZM610.9,120.9h26v108h-26v-108h0Z"/>
          <path d="M651.2,240.7h26.2c4.4,10.1,14.9,14.6,28.6,14.6s31.3-9,31.3-34.1v-9.4c-7.4,12-20.3,18.6-36.5,18.6-25.8,0-53.3-17.3-53.3-55.5s24-56.8,58.1-56.8,57.7,22.7,57.7,57.7v44.6c0,41.3-25.6,57.5-57.3,57.5s-48.1-11.6-54.9-37.2h.1ZM737.3,174.9c0-19-12.7-32.6-31.7-32.6s-31.9,13.6-31.9,32.6,12.9,31.3,31.9,31.3,31.7-12.2,31.7-31.3Z"/>
          <path d="M770,174.9c0-32.8,24-56.8,58.1-56.8s57.7,24,57.7,56.8v9.2h-88.5c3.5,15.7,15.5,24,30.8,24s20.1-3.3,25.6-10.3h27.8c-8.1,20.5-27.8,33.9-53.3,33.9s-58.1-24-58.1-56.8h0ZM858.3,163.3c-4.2-14.4-16-21.6-30.2-21.6s-26,7.4-30.2,21.6h60.4Z"/>
          <path d="M892.7,172.7c0-36.1,21.4-54.6,53.3-54.6s53.3,18.4,53.3,54.6v56.2h-26v-56.2c0-20.5-10.9-30.4-27.3-30.4s-27.3,9.8-27.3,30.4v56.2h-26v-56.2Z"/>
        </g>
      </svg>
    </div>
  )
}
